import { Vector2 } from '@typings/vectors';

export function convertLpColorToCSSColor(color: { r: number; g: number; b: number; a: number }): string {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
}

export function convertLpVector<T extends Vector2>(vector: { x: number; y: number }): T {
  return [vector.x, vector.y] as T;
}
